/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
import { Map, fromJS } from 'immutable';

import {
  SET_REQUEST_STATE,
  RESET_REQUEST_STATE,
  SET_REQUEST_ERROR,
  CLEAR_REQUEST_ERROR,
} from 'actions/actions';
import {
  GET_USER_INFO, UPDATE_USER_INFO, UPDATE_USER_PASSWORD, LOGIN,
  LOGOUT, GET_REPORTS_INFO, SEARCH_USERS,
} from 'actions/asyncActions';


export function loggedOnUser(state = Map(), action) {
  switch (action.type) {
    case GET_USER_INFO.SUCCESS:
    case UPDATE_USER_INFO.SUCCESS:
    case UPDATE_USER_PASSWORD.SUCCESS:
    case LOGIN.SUCCESS:
      return state.merge(fromJS(action.payload));
    case LOGOUT.SUCCESS:
      return Map();
    default:
      return state;
  }
}

export function requestStates(state = Map(), action) {
  const { type, payload } = action;

  const path = ({ actionSet, tag }) =>
    (tag ? [actionSet, tag] : [actionSet]);

  switch (type) {
    case RESET_REQUEST_STATE:
      return state.deleteIn(path(payload));

    case SET_REQUEST_STATE:
      return state.setIn(path(payload), fromJS({ state: payload.state, data: payload.data }));

    default:
      return state;
  }
}

export function hasRequestError(state = false, action) {
  switch (action.type) {
    case CLEAR_REQUEST_ERROR:
      return false;

    case SET_REQUEST_ERROR:
      return true;

    default:
      return state;
  }
}

export function reportsInfo(state = Map(), action) {
  switch (action.type) {
    case GET_REPORTS_INFO.SUCCESS:
      return state.merge(fromJS(action.payload));

    default:
      return state;
  }
}

const initialUserState = {
  users: [],
  usersFound: null,
  usersCount: 0,
};

export function userList(state = initialUserState, action) {
  const { type, payload } = action;

  switch (type) {
    case SEARCH_USERS.SUCCESS:
      return {
        users: payload.results,
        usersFound: payload.results.length > 0,
        usersCount: payload.results.length,
      };

    default:
      return state;
  }
}
